/**
 * Get correct Terms And Conditions
 * @param {Function} t - translation method
 * @param {object} order - order object
 * @param {object} payment - payment object
 * @param {object} theme - theme object
 * @param {object} url - url object
 * @param {string} ctaText - text of the CTA button to be shown in T&C
 * @returns {string}
 */
const termsAndConditions = (t, order, payment, theme, url, ctaText = '') => {
	// Get prices string based on number of products
	const priceString = order.products
		.map(({ name, futurePrice, yearsValidity, monthsValidity }) => {
			return yearsValidity >= 1 ?	t('cart_termsPriceYear', {
				futurePrice: futurePrice?.street?.formatted,
				productName: name
			}) : t('cart_termsPriceMonth', {
				futurePrice: futurePrice?.street?.formatted,
				productName: name,
				validity: monthsValidity
			});
		})
		.join(` ${t('cart_and')} `)
		.trim();
	const providerName = theme.provider.name;
	const translationOptions = Object.assign({
		cart_providerLocale: theme.provider.policyLocale || theme.provider.locale,
		cart_locale: theme.variables.policyLocale || url.locale,
		cart_submit: t(ctaText)
	}, order.hasPricesInTerms ? {
		prices: priceString
	} : {});
	const spacer = '<br><br>';
	// T&Cs strings
	const hasSontiqTerms = order.hasSontiqProduct && url.locale === 'en-us';
	const hasInsuranceTerms = order.hasInsuranceProduct && ['fr-fr', 'de-de'].includes(url.locale);
	const hasNetProphetsResellerTerms = url.locale === 'en-in';
	const terms = {
		trial: t(`cart_termsTrial.${providerName}`, {
			period: order.trialPeriod,
			...translationOptions
		}),
		manualRenewal: t(`cart_termsManualRenewal.${providerName}`, translationOptions),
		autoRenewal: t(`cart_termsAutoRenewal.${providerName}`, translationOptions),
		sontiq: hasSontiqTerms ? `${spacer}${t('cart_termsSontiq', translationOptions)}` : '',
		insurance: hasInsuranceTerms ? `${spacer}${t('cart_termsInsurance', translationOptions)}` : '',
		netProphetsReseller: hasNetProphetsResellerTerms ? `${spacer}${t('cart_termsNetProphetsReseller', translationOptions)}` : '',
		oms: t('cart_termsOms', translationOptions)
	};
	const thirdPartyTerms = `${terms.sontiq}${terms.insurance}${terms.netProphetsReseller}`;
	if (order.hasTrialProduct) {
		// Return T&C - trial products
		return `${terms.trial}${thirdPartyTerms}`;
	} else if (payment.isManualRenewal || order.hasManualRenewalProduct) {
		// Return MR T&C - manual renewal payment methods, MR products
		return `${terms.manualRenewal}${thirdPartyTerms}`;
	} else if (order.isOmsFlow) {
		// Return OMS T&C - General terms are already agreed on before the purchase (B2B only)
		return `${terms.oms}${thirdPartyTerms}`;
	} else {
		// Return AR T&C
		return `${terms.autoRenewal}${thirdPartyTerms}`;
	}
};

export default termsAndConditions;
